import React from 'react'
import { Box, List, ListItem, Typography } from '@mui/material'
import { Vehicle } from '@otw/models'

interface QuotaVehicleListProps {
  vehicles: Vehicle[]
}

export const QuotaVehicleList: React.FC<QuotaVehicleListProps> = ({ vehicles }) => {
  if (vehicles.length === 0) return null

  return (
    <List
      dense
      disablePadding
      sx={{
        mt: 1,
        maxHeight: 220,
        overflow: 'auto',
        bgcolor: 'action.hover',
        borderRadius: 1,
        px: 1,
      }}
    >
      {vehicles.map((vehicle) => {
        const yearMakeModel = [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ')
        const details = [
          vehicle.stock_number ? `Stock #: ${vehicle.stock_number}` : null,
          vehicle.vin ? `VIN: ${vehicle.vin}` : null,
        ]
          .filter(Boolean)
          .join(' · ')

        return (
          <ListItem key={vehicle.id} disableGutters sx={{ py: 0.5, alignItems: 'flex-start' }}>
            <Box>
              <Typography variant="body2" fontWeight={500}>
                {yearMakeModel || 'Unknown vehicle'}
              </Typography>
              {details ? (
                <Typography variant="caption" color="text.secondary">
                  {details}
                </Typography>
              ) : null}
            </Box>
          </ListItem>
        )
      })}
    </List>
  )
}

export default QuotaVehicleList
